// @flow

export { normalizeCustomerDocument } from './normalize-customer-document';
